module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/icon_crystal.2fb655b1.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/icon_crystal.png
// module id = 2998
// module chunks = 11